import { CandidateViewAction, CandidateViewState } from "./candidate.action";

export const candidateViewReducer = (
  state: CandidateViewState,
  action: CandidateViewAction
): CandidateViewState => {
  switch (action.type) {
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};
